import { render, staticRenderFns } from "./Sent.vue?vue&type=template&id=6dcb79bf&scoped=true"
import script from "./Sent.vue?vue&type=script&lang=js"
export * from "./Sent.vue?vue&type=script&lang=js"
import style0 from "./Sent.vue?vue&type=style&index=0&id=6dcb79bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcb79bf",
  null
  
)

export default component.exports